"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Image = exports.Content = exports.Container = exports.ButtonsContainer = exports.Button = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n"])));

exports.Container = Container;

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  ", "\n"])), (0, _layout.setContainer)({
  size: 'sm'
}));

exports.Content = Content;

var Image = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100px;\n  @media (min-width: 768px) {\n    width: 126px;\n  }\n  @media (min-width: 992px) {\n    width: 152px;\n  }\n"])));

exports.Image = Image;

var Title = _styledComponents.default.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: \"univers-cond\", sans-serif;\n  line-height: 35.2px;\n  ", "\n  margin: 32px 0;\n"])), function (props) {
  return props.colorMode === 'dark' ? 'white' : 'inherit';
}, (0, _typography.setFontSizes)({
  mobile: '24px',
  tablet_vertical: '32px'
}));

exports.Title = Title;

var ButtonsContainer = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n\n  button {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) {
  return props.colorMode === 'dark' ? 'white' : 'black';
}, function (props) {
  return props.colorMode === 'dark' ? 'black' : 'white';
});

exports.ButtonsContainer = ButtonsContainer;

var Button = _styledComponents.default.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: \"univers-black\", sans-serif;\n  padding: 15px 20px;\n  width: 100%;\n  border: 0;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 900;\n  line-height: 15.4px;\n  cursor: pointer;\n\n  ", "\n\n  & + button {\n    margin-top: 15px;\n  }\n\n  @media (min-width: 768px) {\n    width: initial;\n    \n    & + button {\n      margin-top: 0;\n      margin-left: 25px;\n    }\n    \n  }\n"])), (0, _typography.setFontSizes)({
  mobile: '14px'
}));

exports.Button = Button;